<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#7e5678"
    :border="false"
    inactive-color="#979799"
    z-index="999"
    class="eharmony-tabbar"
  >
    <van-tabbar-item
      v-for="(item, index) in tabItems"
      :key="item.to"
      :to="item.to"
    >
      <span></span>
      <template #icon>
        <div class="tab">
          <img
            :src="getIconSrc(item.icon, index)"
            :alt="item.icon"
            class="img-icon"
          />
        </div>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0,
      tabItems: [
        { to: "/Home", icon: "home" },
        { to: "/MessageBoard", icon: "time" },
        { to: "/GameN", icon: "like" },
        { to: "/Video", icon: "video" },
        { to: "/Mine", icon: "mine" },
      ],
    };
  },
  methods: {
    getIconSrc(icon, index) {
      const suffix = this.active === index ? "" : "_active";
      return `/img/footer/${icon}${suffix}.png`;
    },
    syncRouteState(routeName) {
      if (routeName == "home") {
        this.active = 0;
        this.show = true;
      } else if (routeName == "MessageBoard") {
        this.active = 1;
        this.show = true;
      } else if (routeName == "choose" || routeName == "GameN") {
        this.active = 2;
        this.show = true;
      } else if (routeName == "game" || routeName == "video") {
        this.active = 3;
        this.show = true;
      } else if (routeName == "mine") {
        this.active = 4;
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  watch: {
    $route(to) {
      this.syncRouteState(to.name);
    },
  },
  created() {
    this.syncRouteState(this.$route.name);
  },
};
</script>

<style lang="less" scoped>
.eharmony-tabbar {
  box-sizing: border-box;
  width: 100%;
  height: 148px;
  padding: 16px 14px 24px;
  background: #fff;
}

.tab {
  width: 100%;
  max-width: 104px;
  height: 68px;
  margin: 0 auto;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.img-icon {
  width: 42px;
  height: 42px;
  object-fit: contain;
}

::v-deep .van-tabbar-item {
  color: transparent;
  flex: 1 1 20%;
  min-width: 0;
  padding: 0;
}

::v-deep .van-tabbar-item__text {
  display: none;
}

::v-deep .van-tabbar-item__icon {
  margin-bottom: 0;
  width: 100%;
}

::v-deep .van-tabbar-item--active {
  background: transparent;
}

::v-deep .van-tabbar-item--active .tab {
  background: #6667e8;
}
</style>
